import { put, takeEvery } from 'redux-saga/effects'
import { FETCH_CANCELLED_JOBS, FETCHING_CANCELLED_JOBS, CANCELLED_JOBS_FETCHED } from '../actions/cancelledJob'
import jobService from '../../services/job'

function * fetchJobs ({ loading, currentPage, pageSize, filter, sort, searchText }) {
  try {
    yield put({ type: FETCHING_CANCELLED_JOBS, loading })
    const jobs = yield jobService.getCancelledJob(currentPage, pageSize, filter, sort, searchText)
    yield put({ type: CANCELLED_JOBS_FETCHED, jobs, loading: false })
  } catch (e) {
    yield put({ type: FETCHING_CANCELLED_JOBS, loading: false })
    console.error(e)
  }
}

function * watchCancelledJobs () {
  yield takeEvery(FETCH_CANCELLED_JOBS, fetchJobs)
}

export default watchCancelledJobs
